import { BASE_URL } from "../utils/BaseUrl"
import httpRequest from "../utils/httpsRequest";

export const SignIn = async (payload) => {
  return await httpRequest(`${BASE_URL}/ManageUser/ManagementAccess?UserName=${encodeURIComponent(payload.UserName)}&PassWord=${encodeURIComponent(payload.PassWord)}`, "post" );
}